import React from 'react';

export default function Footer({ lang }) {
  lang = lang.toLowerCase();
  return <div dangerouslySetInnerHTML={{ __html: window.getFooter ? window.getFooter({ lang }) : '' }}></div>
}